import { render, staticRenderFns } from "./Partages.vue?vue&type=template&id=4af8e3b6&"
import script from "./Partages.vue?vue&type=script&lang=js&"
export * from "./Partages.vue?vue&type=script&lang=js&"
import style0 from "./Partages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports